import { Swiper, Navigation } from 'swiper';
import focusLock from 'dom-focus-lock';
import { breakpoints } from '../../config/breakpoints';

const header = () => document.querySelector('.header');
const { md } = breakpoints;

let floorPlansSwiper = null;
let shouldShowFocusRing = false;

document.addEventListener('keydown', (event) => {
  if (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
    shouldShowFocusRing = true;
  }
}, true);

document.addEventListener('mousedown', () => {
  shouldShowFocusRing = false;
}, true);

const isModalOpen = () => {
  const modal = document.getElementById('floorPlansModal');
  return modal && getComputedStyle(modal).display !== 'none';
};

const isMobileViewport = () => window.innerWidth < md;

function syncHeaderZIndex() {
  const el = header();
  if (!el) {
    return;
  }

  if (isModalOpen() && isMobileViewport()) {
    el.style.setProperty('z-index', '2');
  } else {
    el.style.removeProperty('z-index');
  }
}

function initSwiper() {
  if (floorPlansSwiper) {
    floorPlansSwiper.destroy(true, true);
  }

  floorPlansSwiper = new Swiper('.floor-plans-dialog__slider', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    navigation: {
      nextEl: '.floor-plans-dialog__arrow--next .floor-plans-dialog__arrow-btn',
      prevEl: '.floor-plans-dialog__arrow--prev .floor-plans-dialog__arrow-btn',
    },
  });
}

function openModal(templateId) {
  const wrapper = document.getElementById('floorPlansSliderWrapper');
  if (!wrapper) return;

  wrapper.innerHTML = '';

  const template = document.querySelector(templateId);
  if (!template) return;

  const slides = template.content.cloneNode(true);
  const slideElements = slides.querySelectorAll('.swiper-slide');

  if (!slideElements.length) return;

  const isSingleImage = slideElements.length === 1;
  const modal = document.getElementById('floorPlansModal');
  const arrows = modal?.querySelectorAll('.floor-plans-dialog__arrow');

  slideElements.forEach((slide) => {
    wrapper.appendChild(slide.cloneNode(true));
  });

  if (isSingleImage) {
    arrows?.forEach((arrow) => {
      const arrowElement = arrow;
      arrowElement.style.display = 'none';
    });
  } else {
    arrows?.forEach((arrow) => {
      const arrowElement = arrow;
      arrowElement.style.display = 'flex';
    });
  }

  modal.style.display = 'flex';
  document.getElementById('floorPlansOverlay').style.display = 'block';
  document.body.classList.add('overflow-hidden');
  document.body.classList.add('floor-plans-open');

  // Blur before activating the trap on mouse-click so focusLock's
  // activateTrap() sees focus on body (isFreeFocus = true) and skips
  // its auto-redirect into the modal.
  if (!shouldShowFocusRing) {
    document.activeElement?.blur();
  }
  focusLock.on(modal);

  syncHeaderZIndex();

  setTimeout(() => {
    if (!isSingleImage) {
      initSwiper();
    }

    if (shouldShowFocusRing) {
      document.querySelector('.floor-plans-dialog__button')?.focus();
    }
  }, 100);
}

function closeModal() {
  const modal = document.getElementById('floorPlansModal');

  focusLock.off(modal);

  modal.style.display = 'none';
  document.getElementById('floorPlansOverlay').style.display = 'none';
  document.body.classList.remove('overflow-hidden');
  document.body.classList.remove('floor-plans-open');

  if (floorPlansSwiper) {
    floorPlansSwiper.destroy(true, true);
    floorPlansSwiper = null;
  }

  syncHeaderZIndex();
}

let wasMobile = isMobileViewport();

window.addEventListener('resize', () => {
  const mobile = isMobileViewport();
  if (mobile === wasMobile) {
    return;
  }
  wasMobile = mobile;
  syncHeaderZIndex();
});

function bindFloorPlansTrigger(trigger) {
  const openFromTrigger = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const templateId = trigger.getAttribute('data-floor-plans-target');
    if (templateId) {
      openModal(templateId);
    }
  };

  trigger.addEventListener('click', openFromTrigger);
  trigger.addEventListener('keydown', (event) => {
    if (trigger.tagName === 'A' && (event.key === ' ' || event.key === 'Spacebar')) {
      openFromTrigger(event);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const floorPlansDialog = document?.querySelector('#floorPlansModal');
  if (floorPlansDialog) {
    const floorPlansTriggers = '.c-button--floor-plans';
    const floorPlansCloseBtn = '.floor-plans-dialog__button';

    document.querySelectorAll(floorPlansTriggers).forEach((trigger) => {
      bindFloorPlansTrigger(trigger);
    });

    document.querySelector(floorPlansCloseBtn)?.addEventListener('click', closeModal);
    document.querySelector('.floor-plans-dialog__overlay')?.addEventListener('click', closeModal);

    floorPlansDialog.addEventListener('click', (event) => {
      const popupContent = event.target.closest(
        '.floor-plans-dialog__image, .floor-plans-dialog__arrow-btn, .floor-plans-dialog__button',
      );

      if (!popupContent) {
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isModalOpen()) {
        closeModal();
      }
    });
  }
});
